<label  [attr.for]="id || for" class="field__label">{{label}}</label>
<select [ngModel]="selectedValue" (ngModelChange)="onChange($event)" (blur)="onBlur()" [id]="id" [disabled]="disabled"
    class="field__input" [ngClass]="{'field__input--error': errorMessages.length}" [attr.aria-describedby]="getDescribedBy()" [attr.aria-invalid]="errorMessages.length>0">
    <option *ngFor="let option of options" value="{{option.value}}">{{option.text}}</option>
</select>
<div *ngIf="errorMessages.length"
     [id]="(id||for)+'-error'"
     class="error-message"
     aria-live="assertive"
     aria-atomic="true"
     role="alert">
    <ErrorMessages [errorMessages]="errorMessages" [id]="getDescribedBy()"></ErrorMessages>
</div>
